import { lazy, type FC } from 'react';

const Page = lazy(
  () => import('src/pages/settings/integration-client-auth/page')
);

export const IntegrationClientAuth: FC = () => {
  return <Page />;
};
